import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";
import { CompanyInstructionDispatcher } from "./Variable";
import { FirmInstruction } from "../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { any } from "prop-types";

export interface CompanyInstructionStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: FirmInstruction;
    update?: any;
}

export class CompanyInstructionStoreStatic extends BaseStore<CompanyInstructionStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(CompanyInstructionDispatcher, (actionData) =>
            this.onCompanyInstructionStoreResponse(actionData)
        );
    }

    public getLastResult(): CompanyInstructionStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): CompanyInstructionStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
            update: any,
        };
    }

    private onCompanyInstructionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, update: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
